import { toast } from "react-toastify";
import APIPaths from "../../utils/APIPaths";
import axiosInstance from "../axiosInstance";

export const getAllCertificateTemplates = async (
  page,
  rowsPerPage,
  searchData
) => {
 
  try {
    const URL = `${APIPaths.GET_ALL_CERTIFICATE_TEMPLATES}/${page}/${rowsPerPage}`;
    const response = await axiosInstance.get(URL, {
      params: {
        searchText: searchData,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 204) {
      return response.data;
    }
  } catch (error) {
   
  }
};

export const addCertificateTemplate = async (bodyObj) => {
  try {
    const URL = APIPaths.ADD_CERTIFICATE_TEMPLATE;
    const response = await axiosInstance.post(URL, bodyObj);
    if (response.status === 201) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const updateCertificateTemplate = async (bodyObj,id) => {
  try {
    const URL = `${APIPaths.UPDATE_CERTIFICATE_TEMPLATE}${id}`;
    const response = await axiosInstance.put(URL, bodyObj);
    if (response && response.status === 200) {
      toast.success(response?.data?.message);
      return response.data;
    }
    return null;
  } catch (error) {
     if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong");
    }
  }
};

export const deleteCertificateTemplate = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_CERTIFICATE_TEMPLATE}${id}`
    );
    if (response.status === 200) {
      toast.success("Certificate deleted successfully.");
      return response.data;
    }
  } catch (error) {
     if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong");
    }
  }
};


export const viewCertificateTemplatePDF = async (certificateTemplateId, data) => {
  try {
    const URL = `${APIPaths.DOWNLOAD_CERTIFICATE_TEMPLATE_PDF}/${certificateTemplateId}`;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutInstructionDto: data,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View file failed");
  }
};



export const downloadCertificateTemplatePDF = async (certificateTemplateId, data) => {
  try {
      const URL = `${APIPaths.DOWNLOAD_CERTIFICATE_TEMPLATE_PDF}/${certificateTemplateId}`;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutInstructionDto: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Certificate  not available");
    }
  } catch (error) {
    toast.error("File download failed");
  }
};

export const generateCertificateForClient= async (bodyObj) => {
  try {
    const URL = APIPaths.GENERATE_CERTIFICATE_FOR_CLIENT;
    const response = await axiosInstance.post(URL, bodyObj);
    if (response.status === 201) {
      toast.success(response?.data?.message);
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};


export const getAllCertificateByClientId = async (
  page,
  rowsPerPage,
  clientId
) => {
  try {
    const URL = `${APIPaths.GET_ALL_ACCEPTED_CERTIFICATES_BY_CLIENTID}/${clientId}/${page}/${rowsPerPage}`;
    const response = await axiosInstance.get(URL);
  
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 204) {
      return response.data;
    }
  } catch (error) {
   
  }
};

export const viewCertificatePDF = async (certificateId, data) => {
  try {
    const URL = `${APIPaths.DOWNLOAD_CERTIFICATE_PDF_BY_ID}/${certificateId}`;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutInstructionDto: data,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View file failed");
  }
};


export const downloadCertificatePDF = async (certificateId, data) => {
  try {
    const URL = `${APIPaths.DOWNLOAD_CERTIFICATE_PDF_BY_ID}/${certificateId}`;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutInstructionDto: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Certificate  not available");
    }
  } catch (error) {
    toast.error("File download failed");
  }
};

